import { render, staticRenderFns } from "./base-textarea.vue?vue&type=template&id=b0b09850&"
import script from "./base-textarea.vue?vue&type=script&lang=js&"
export * from "./base-textarea.vue?vue&type=script&lang=js&"
import style0 from "./base-textarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports